var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33305 2.00005C9.33305 0.896024 8.43703 0 7.333 0H2.00005C0.896024 0 0 0.896024 0 2.00005V7.333C0 8.43703 0.896024 9.33305 2.00005 9.33305H7.333C8.43703 9.33305 9.33305 8.43703 9.33305 7.333V2.00005ZM8.00021 2.00005V7.333C8.00021 7.70101 7.70101 8.00021 7.333 8.00021H2.00005C1.63204 8.00021 1.33284 7.70101 1.33284 7.333V2.00005C1.33284 1.63204 1.63204 1.33284 2.00005 1.33284H7.333C7.70101 1.33284 8.00021 1.63204 8.00021 2.00005Z",
    fill: "#F2EADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33305 12.667C9.33305 11.563 8.43703 10.667 7.333 10.667H2.00005C0.896024 10.667 0 11.563 0 12.667V18C0 19.104 0.896024 20 2.00005 20H7.333C8.43703 20 9.33305 19.104 9.33305 18V12.667ZM8.00021 12.667V18C8.00021 18.368 7.70101 18.6672 7.333 18.6672H2.00005C1.63204 18.6672 1.33284 18.368 1.33284 18V12.667C1.33284 12.299 1.63204 11.9998 2.00005 11.9998H7.333C7.70101 11.9998 8.00021 12.299 8.00021 12.667Z",
    fill: "#F2EADF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 2.00005C20 0.896024 19.104 0 18 0H12.667C11.563 0 10.667 0.896024 10.667 2.00005V7.333C10.667 8.43703 11.563 9.33305 12.667 9.33305H18C19.104 9.33305 20 8.43703 20 7.333V2.00005ZM18.6672 2.00005V7.333C18.6672 7.70101 18.368 8.00021 18 8.00021H12.667C12.299 8.00021 11.9998 7.70101 11.9998 7.333V2.00005C11.9998 1.63204 12.299 1.33284 12.667 1.33284H18C18.368 1.33284 18.6672 1.63204 18.6672 2.00005Z",
    fill: "#F2EADF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12.667C20 11.563 19.104 10.667 18 10.667H12.667C11.563 10.667 10.667 11.563 10.667 12.667V18C10.667 19.104 11.563 20 12.667 20H18C19.104 20 20 19.104 20 18V12.667ZM18.6672 12.667V18C18.6672 18.368 18.368 18.6672 18 18.6672H12.667C12.299 18.6672 11.9998 18.368 11.9998 18V12.667C11.9998 12.299 12.299 11.9998 12.667 11.9998H18C18.368 11.9998 18.6672 12.299 18.6672 12.667Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.2b2d35f1838acb5873aa9ab558522f1e.svg";
export { ForwardRef as ReactComponent };